<template>
  <!-- // TODO Task: MediaLibrary Redesign - Comment: Redesign the MedieLibrary component -->
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <div class="mb-2">
          <div class="d-flex justify-content-end">
            <div>
              <label for="uploadmyfile">
                <!-- <div class="bg-primary text-white p-2 rounded"><b-icon icon="upload" aria-hidden="true"></b-icon> Upload Image</div> -->
                <!-- <b-button variant="primary"> <b-icon icon="upload" aria-hidden="true"></b-icon> Upload file</b-button> -->
              </label>
              <input type="file" id="uploadmyfile" multiple class="d-none" @change="upload($event)" />
            </div>
            <b-dropdown right variant="link" class="p-0" toggle-class="p-0" no-caret>
              <template #button-content>
                <b-icon class="ml-2" icon="three-dots-vertical" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
              </template>
              <b-dropdown-item>New Folder</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div>
          <b-breadcrumb>
            <b-breadcrumb-item v-on:click="navigate(breadcrumb.reference, index)" v-for="(breadcrumb, index) in breadcrumbs" :key="index" :active="breadcrumb.active">
              <b-icon v-if="index == 0" icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
              {{ breadcrumb.text }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </b-col>
      <b-col cols="8">
        <div>
          <!-- <b-form-checkbox v-model="checkedReferences" value="test"> </b-form-checkbox> -->
          <div class="d-flex align-items-center" v-for="(folder, index) in refs.folders" :key="'folder' + index">
            <!-- <b-form-checkbox v-model="checkedReferences" :value="folder['_location']['path_']"> </b-form-checkbox> -->
            <b-icon icon="folder" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            <a href="#" class="ml-2" v-on:click="load(folder)">{{ folder.name }}</a>
          </div>
          <div class="d-flex align-items-center" v-for="(file, index) in refs.files" :key="'file' + index">
            <template v-if="multiple">
              <b-form-checkbox v-model="checkedReferences" :value="file"> </b-form-checkbox>
            </template>
            <b-icon icon="file-earmark" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            <a href="#" class="ml-2" v-on:click="open(file)">{{ file.name }}</a>
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="bg-white" v-if="currentFile">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <h6>{{ currentFile.meta.name }}</h6>
            <img class="w-50" :src="currentFile.src" alt="" />
            <template v-if="multiple">
              <b-button class="mt-2" variant="primary" v-on:click="loadGallery">Use Images</b-button>
            </template>
            <template v-else>
              <b-button class="mt-2" variant="primary" v-on:click="$emit('select', currentFile)">Use Image</b-button>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MediaLibrary',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedReferences: [],
      breadcrumbs: [],
      refs: {
        folders: [],
        files: [],
      },
      currentFile: {
        reference: {},
        meta: {},
        src: '',
      },
      firstname: 'Bob',
      lastname: 'Marley',
    }
  },
  created() {
    this.getStorageReference({ reference: '/' }).then((ref) => {
      this.load(ref)
    })
  },
  methods: {
    ...mapActions(['getStorageReference', 'uploadToStorage', 'listStorage', 'getMetadata', 'downloadFromStorage']),
    upload(e) {
      Array.from(e.target.files).forEach((file) => {
        this.uploadToStorage({
          file,
          reference: `${this.getFullPath()}/${file.name}`,
        })
      })
    },
    open(file) {
      this.getMetadata({ reference: file })
        .then((meta) => {
          this.currentFile.meta = meta
          return this.downloadFromStorage({ reference: file })
        })
        .then((src) => {
          this.currentFile.src = src
        })
    },
    getFullPath() {
      return this.breadcrumbs[this.breadcrumbs.length - 1].reference['_location']['path_']
    },
    navigate(reference, index) {
      this.breadcrumbs = this.breadcrumbs.slice(0, index)
      this.load(reference)
    },
    loadGallery() {
      console.log('loading gallery')
      const files = []
      const promises = this.checkedReferences.map(async (reference) => {
        const src = await this.downloadFromStorage({ reference })
        files.push(src)
      })

      Promise.all(promises).then(() => {
        console.log('emmiting', files)
        this.$emit('select', files)
      })
    },
    load(reference) {
      this.listStorage({ folderRef: reference })
        .then((res) => {
          this.refs.folders = res.prefixes
          this.refs.files = res.items
          if (this.breadcrumbs.length != 0) {
            this.breadcrumbs[this.breadcrumbs.length - 1].active = !1
          }
          this.breadcrumbs.push({
            text: reference['_location']['path_'].split('/').at(-1),
            reference,
            active: !0,
          })
        })
        .catch(console.log)
    },
  },
}
</script>
